var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendario1White(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 16H1.83337C0.822021 16 0 15.178 0 14.1666V3.16663C0 2.15527 0.822021 1.33337 1.83337 1.33337H14.1666C15.178 1.33337 16 2.15527 16 3.16663V14.1666C16 15.178 15.178 16 14.1666 16ZM1.83337 2.33337C1.37402 2.33337 1 2.70728 1 3.16663V14.1666C1 14.626 1.37402 15 1.83337 15H14.1666C14.626 15 15 14.626 15 14.1666V3.16663C15 2.70728 14.626 2.33337 14.1666 2.33337H1.83337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.33337H0.5C0.223999 6.33337 0 6.10938 0 5.83337C0 5.55737 0.223999 5.33337 0.5 5.33337H15.5C15.776 5.33337 16 5.55737 16 5.83337C16 6.10938 15.776 6.33337 15.5 6.33337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8335 4C3.5575 4 3.3335 3.776 3.3335 3.5V0.5C3.3335 0.223999 3.5575 0 3.8335 0C4.1095 0 4.3335 0.223999 4.3335 0.5V3.5C4.3335 3.776 4.1095 4 3.8335 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.167 4C11.891 4 11.667 3.776 11.667 3.5V0.5C11.667 0.223999 11.891 0 12.167 0C12.443 0 12.667 0.223999 12.667 0.5V3.5C12.667 3.776 12.443 4 12.167 4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario1White);
export default __webpack_public_path__ + "static/media/calendario 1-white.996426af8cf76b5a7ee10206ba2f1fbb.svg";
export { ForwardRef as ReactComponent };